var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148589",
    "data-name": "Rectangle 148589",
    width: 24,
    height: 24,
    fill: "#ff411a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alarm",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alarm-clock",
    transform: "translate(1.974 1.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11717",
    "data-name": "Group 11717",
    transform: "translate(2.12 2.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11716",
    "data-name": "Group 11716",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8854",
    "data-name": "Path 8854",
    d: "M64.408,81.242a7.89,7.89,0,1,0-11.393,0l-2.05,2.733a.717.717,0,0,0,1.148.861l1.987-2.65a7.832,7.832,0,0,0,9.224,0l1.987,2.65a.717.717,0,0,0,1.148-.861ZM59.428,75.8a.717.717,0,0,1-.143.43L57.133,79.1a.717.717,0,0,1-1.148-.861l2.008-2.678V71.494a.717.717,0,1,1,1.435,0v4.3Z",
    transform: "translate(-50.821 -67.893)",
    fill: "#ff411a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11719",
    "data-name": "Group 11719",
    transform: "translate(0 0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11718",
    "data-name": "Group 11718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8855",
    "data-name": "Path 8855",
    d: "M6.468,1.765A3.586,3.586,0,0,0,1.4,6.836a.717.717,0,0,0,1.014,0L6.468,2.779A.717.717,0,0,0,6.468,1.765Z",
    transform: "translate(-0.378 -0.746)",
    fill: "#ff411a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11721",
    "data-name": "Group 11721",
    transform: "translate(13.72 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11720",
    "data-name": "Group 11720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8856",
    "data-name": "Path 8856",
    d: "M332.109,1.049a3.586,3.586,0,0,0-5.071,0,.717.717,0,0,0,0,1.014l4.057,4.057a.717.717,0,0,0,1.014,0A3.586,3.586,0,0,0,332.109,1.049Z",
    transform: "translate(-326.828 0.001)",
    fill: "#ff411a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmLarge);
export default __webpack_public_path__ + "static/media/alarm-large.2519ad31.svg";
export { ForwardRef as ReactComponent };